import AssistChip from 'LuxKit/Chips/AssistChip'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import useToggle from 'hooks/useToggle'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import useExperiencesSortOptions from '../hooks/useExperiencesSortOptions'
import ExperiencesSortByOptions from './ExperiencesSortByOptions'

const DropdownContent = styled.div`
  padding-inline: ${rem(16)};
`

function ExperienceSearchPageSort() {
  const intl = useIntl()
  const [open, toggleSort, _, closeSort] = useToggle()
  const triggerRef = useRef<HTMLButtonElement>(null)
  const { sortBy, sortOptions } = useExperiencesSortOptions()

  return (
    <>
      <AssistChip
        variant="filled"
        size="medium"
        onClick={toggleSort}
        endIcon={<LineAngleDownIcon />}
        ref={triggerRef}
      >
        {intl.formatMessage({
          id: 'biuHNo2XDjdT5f8l_1L3',
          defaultMessage: 'Sort: {sortOption}',
          description: 'Sort button label showing the currently selected sort option in experience search',
        }, { sortOption: sortOptions[sortBy]?.label })}
      </AssistChip>
      <DropdownList
        size="S"
        open={open}
        onClose={closeSort}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        data-testid="sort-options-dropdown"
      >
        <DropdownContent>
          <ExperiencesSortByOptions />
        </DropdownContent>
      </DropdownList>
    </>
  )
}

export default ExperienceSearchPageSort
